import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// interface WatchHistoryItem {
//   videoId: string;
// }

// interface WatchHistoryState {
//   watchHistoryVideos: WatchHistoryItem[];
// }

const initialState: any = {
    exams: []
};

export const examSlice = createSlice({
  name: 'exams',
  initialState,
  reducers: {
    setExams: (state, action: PayloadAction<any[]>) => {
      state.exams = action.payload;
    }
  }
});

export const { setExams } = examSlice.actions;

export default examSlice.reducer;
